import { baseApi } from './base.api';
import { API_VERSION, PATH_CONFIGURATION_API } from '../constants/api-routes';

export const configurationService = baseApi.injectEndpoints({
  endpoints: (build): any => {
    return {
      getDefaultConfigurationTemplateFields: build.query({
        query: () => {
          const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;

          return {
            url: `${version}/${PATH_CONFIGURATION_API.DEFAULT_TEMPLATE_FIELDS}`,
          };
        },
        providesTags: ['defaultTemplateFields'],
      }),
      getCustomTemplates: build.query({
        query: () => {
          const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;

          return {
            url: `${version}/${PATH_CONFIGURATION_API.CUSTOM_TEMPLATES}`,
          };
        },
        providesTags: ['customTemplates'],
      }),
      getAllConfigurationSettings: build.query({
        query: ({ id, page = 1 }) => {
          const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
          const ROOT =
            version === API_VERSION.V1
              ? PATH_CONFIGURATION_API.ROOT_PROJECT
              : PATH_CONFIGURATION_API.ROOT_PROJECTS;

          return {
            url: `${version}/${ROOT}/${id}/settings?page=${page}&page_size=100`,
          };
        },
        providesTags: ['ConfigurationSettings'],
      }),
      createConfigurationSettings: build.mutation({
        query: ({ id, body }) => {
          const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
          const ROOT =
            version === API_VERSION.V1
              ? PATH_CONFIGURATION_API.ROOT_PROJECT
              : PATH_CONFIGURATION_API.ROOT_PROJECTS;

          return {
            url: `${version}/${ROOT}/${id}/settings`,
            method: 'POST',
            body,
          };
        },
        async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
          try {
            const { data: settings } = await queryFulfilled;
            const page = 1;

            dispatch(
              configurationService.util.updateQueryData(
                'getAllConfigurationSettings',
                { id, page },
                (draft: any) => {
                  draft.page_info.total_items = draft.page_info.total_items + 1;
                  draft.items.unshift(settings);
                },
              ),
            );
          } catch {}
        },
      }),
      deployConfigurationSettings: build.mutation({
        query: ({ project_id, settings_id, body = {} }) => {
          const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
          const ROOT =
            version === API_VERSION.V1
              ? PATH_CONFIGURATION_API.ROOT_PROJECT
              : PATH_CONFIGURATION_API.ROOT_PROJECTS;

          return {
            url: `${version}/${ROOT}/${project_id}/settings/${settings_id}/deploy`,
            method: 'POST',
            body,
          };
        },
        invalidatesTags: ['ConfigurationSettings'],
      }),
      getConfigurationSettingsPrompt: build.query({
        query: ({ project_id, settings_id }) => {
          const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
          const ROOT =
            version === API_VERSION.V1
              ? PATH_CONFIGURATION_API.ROOT_PROJECT
              : PATH_CONFIGURATION_API.ROOT_PROJECTS;

          return {
            url: `${version}/${ROOT}/${project_id}/settings/${settings_id}/prompt`,
          };
        },
        providesTags: ['ConfigurationSettingsPrompt'],
      }),
      updateConfigurationSettingsPrompt: build.mutation({
        query: ({ project_id, settings_id, body }) => {
          const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
          const ROOT =
            version === API_VERSION.V1
              ? PATH_CONFIGURATION_API.ROOT_PROJECT
              : PATH_CONFIGURATION_API.ROOT_PROJECTS;

          return {
            url: `${version}/${ROOT}/${project_id}/settings/${settings_id}/prompt`,
            method: 'PUT',
            body,
          };
        },
        async onQueryStarted({ project_id, settings_id, body }, { dispatch, queryFulfilled }) {
          try {
            const { data: settings } = await queryFulfilled;
            dispatch(
              configurationService.util.updateQueryData(
                'getConfigurationSettingsPrompt',
                { project_id, settings_id },
                (draft) => {
                  Object.assign(draft, settings);
                },
              ),
            );
          } catch {}
        },
      }),
    };
  },
});

export const {
  useGetDefaultConfigurationTemplateFieldsQuery,
  useGetAllConfigurationSettingsQuery,
  useGetCustomTemplatesQuery,
  useGetConfigurationSettingsPromptQuery,
  useLazyGetConfigurationSettingsPromptQuery,
  useCreateConfigurationSettingsMutation,
  useDeployConfigurationSettingsMutation,
  useUpdateConfigurationSettingsPromptMutation,
} = configurationService;
